export default __webpack_public_path__ + "static/media/screen2.78184b15.png";